import React, {createRef, useContext, useState} from "react";
import "./StartupProjects.scss";
import {bigProjects, /*smallProjects*/} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import ColorThief from "colorthief";

export default function StartupProject() {

    const [colorArrays, setColorArrays] = useState([]);
    const imgRef = createRef();
  function openUrlInNewTab(url) {
    if (!url) {
      return;
    }
    var win = window.open(url, "_blank");
    win.focus();
  }

  const {isDark} = useContext(StyleContext);
  if (!bigProjects.display) {
    return null;
  }

    function getColorArrays() {
        const colorThief = new ColorThief();
        if (imgRef.current && imgRef.current.complete && imgRef.current.naturalWidth) {
            setColorArrays(colorThief.getColor(imgRef.current));
        }
    }

  function rgb(values) {
        return typeof values === "undefined"
            ? null
            : "rgb(" + values.join(", ") + ")";
  }

  const GetDescBullets = ({descBullets, isDark}) => {
        return descBullets
            ? descBullets.map((item, i) => (
                <li
                    key={i}
                    className={isDark ? "subTitle dark-mode-text" : "subTitle"}
                >
                    {item}
                </li>
            ))
            : null;
  };
  return (
    <> 
<Fade bottom duration={1000} distance="20px">
      <div className="main" id="projects">
        <div>
          <h1 className="skills-heading">{bigProjects.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {bigProjects.subtitle}
          </p>

          <div className="projects-container">
            {bigProjects.projects.map((project, i) => {
              return (
                /*<div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode project-card project-card-dark"
                      : "project-card project-card-light"
                  }
                >
                  {project.image ? (
                    <div className="project-image">
                      <img
                        src={project.image}
                        alt={project.projectName}
                        className="card-image"
                      ></img>
                    </div>
                  ) : null}
                  <div className="project-detail">
                    <h5
                      className={isDark ? "dark-mode card-title" : "card-title"}
                    >
                      {project.projectName}
                    </h5>
                    <p
                      className={
                        isDark ? "dark-mode card-subtitle" : "card-subtitle"
                      }
                    >
                      {project.projectDesc}
                    </p>
                      <ul>
                          <GetDescBullets descBullets={project.descBullets} isDark={isDark} />
                      </ul>
                    {project.footerLink ? (
                      <div className="project-card-footer">
                        {project.footerLink.map((link, i) => {
                          return (
                            <span
                              key={i}
                              className={
                                isDark ? "dark-mode project-tag" : "project-tag"
                              }
                              onClick={() => openUrlInNewTab(link.url)}
                            >
                              {link.name}
                            </span>
                          );
                        })}
                      </div>
                    ) : null}
                  </div>
                </div>*/
                  <div className={isDark ? "experience-card-dark" : "experience-card"}>
                      <div style={{background: rgb(colorArrays)}} className="experience-banner">
                          <div className="experience-blurred_div"></div>
                          <div className="experience-div-company">
                              <h5 className="experience-text-company">{project.projectName}</h5>
                          </div>

                          <img
                              crossOrigin={"anonymous"}
                              ref={imgRef}
                              className="experience-roundedimg"
                              src={project.image}
                              alt={project.projectName}
                              onLoad={() => getColorArrays()}
                          />
                      </div>
                      <div className="experience-text-details">
                          <p
                              className={
                                  isDark
                                      ? "subTitle experience-text-desc dark-mode-text"
                                      : "subTitle experience-text-desc"
                              }
                              style={{ textAlign: 'left' }}
                          >
                              {project.projectDesc}
                          </p>
                          <ul>
                              <GetDescBullets descBullets={project.descBullets} isDark={isDark} />
                          </ul>
                          <div style={{ display: 'flex', justifyContent: 'center' }}>
                              {project.footerLink ? (
                                  <div className="project-card-footer">
                                      {project.footerLink.map((link, i) => {
                                          return (
                                              <span
                                                  key={i}
                                                  className={
                                                      isDark ? "dark-mode project-tag" : "project-tag"
                                                  }
                                                  onClick={() => openUrlInNewTab(link.url)}
                                              >
                              {link.name}
                            </span>
                                          );
                                      })}
                                  </div>
                              ) : null}
                          </div>
                      </div>
                  </div>

              );
            })}
          </div>
        </div>
      </div>
    </Fade>
    <div> 
   {/* <Fade bottom duration={1000} distance="20px">
      <div className="main" id="projects">
        <div>
          <h1 className="skills-heading">{smallProjects.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {smallProjects.subtitle}
          </p>

          <div className="projects-container">
            {smallProjects.projects.map((project, i) => {
              return (
                <div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode project-card project-card-dark"
                      : "project-card project-card-light"
                  }
                >
                  {project.image ? (
                    <div className="project-image">
                      <img
                        src={project.image}
                        alt={project.projectName}
                        className="card-image"
                      ></img>
                    </div>
                  ) : null}
                  <div className="project-detail">
                    <h5
                      className={isDark ? "dark-mode card-title" : "card-title"}
                    >
                      {project.projectName}
                    </h5>
                    <p
                      className={
                        isDark ? "dark-mode card-subtitle" : "card-subtitle"
                      }
                    >
                      {project.projectDesc}
                    </p>
                    {project.footerLink ? (
                      <div className="project-card-footer">
                        {project.footerLink.map((link, i) => {
                          return (
                            <span
                              key={i}
                              className={
                                isDark ? "dark-mode project-tag" : "project-tag"
                              }
                              onClick={() => openUrlInNewTab(link.url)}
                            >
                              {link.name}
                            </span>
                          );
                        })}
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Fade>*/}
    </div>
    </>
    
  );
}
